// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://cms.swaminarayanbhagwan.org:36895',
  bhajanYagApiUrl: 'https://dev.swaminarayanbhagwan.org:15000/wp-json/sb/v1',
  // apiUrl:'https://localhost:44358',
  websiteUrl: 'https://uat.swaminarayanbhagwan.org/en/thalbhet',
  // apiUrlLogin:'https://dev.swaminarayanbhagwan.org:15000/wp-json/sb/v1',
  apiUrlLogin: 'https://cms.swaminarayanbhagwan.org/wp-json/sb/v1',
  YTDAmountLimit: 40000,
  shareUrl: 'https://smk.org/en',
  iframeParentOrigin: '*',
  firebase: {
    apiKey: 'AIzaSyBZcWHmID_7X4jTEKE0s8m9RABRIg9fFvg',
    authDomain: 'sbwebappnotification.firebaseapp.com',
    databaseURL: 'https://sbwebappnotification.firebaseio.com',
    projectId: 'sbwebappnotification',
    storageBucket: 'sbwebappnotification.appspot.com',
    messagingSenderId: '495973469019',
    appId: '1:495973469019:web:6a003d1dcf4ee4cbf4687e',
  },
  staticValues: {
    kundalAmountId: 257,
    vadodaraAmountId: 258,
    wantPrasadQuestionId: 286,
    prasadQuantityQuestionId: 10363,
    minValueForKundal: 500,
    minValueForVadodara: 500,
  },
  yagnaQuestionIds: {
    dateQuestionId: 10512,
    timeSlotQuestionId: 10513,
    nameQuestionId: 10514,
    ageQuestionId: 10515,
    genderQuestionId: 10516,
    bhaktIdQuestionId: 10518,
    smkIdQuestionId: 10522,
    mobileQuestionId: 10523,
    villageQuestionId: 10524,
    parichitBhaktSMKNoQuestionId: 10530,
    parichitBhaktNameQuestionId: 10531,
    parichitBhaktMobileQuestionId: 10532,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
